import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "pdfCompany",
  class: "bule_list_page_RI p-3",
  style: {"color":"#fff","min-height":"calc(100vh - 100px)"}
}
const _hoisted_2 = { class: "flex items-center my-2" }
const _hoisted_3 = { class: "pr-4" }
const _hoisted_4 = { class: "px-5 py-5 rounded-md flex items-center justify-between" }
const _hoisted_5 = { class: "text-xl pr-2" }
const _hoisted_6 = { class: "text-xl flex items-center space-x-2 text-gray-500 print:sr-only" }
const _hoisted_7 = { class: "my-2 flex items-center flex-wrap space-x-0 md:flex-nowrap md:space-x-2 fff" }
const _hoisted_8 = { class: "rounded-md p-3 my-2 box w-1/2 md:w-1/3 print:1/3" }
const _hoisted_9 = {
  id: "chartA",
  class: "w-full h-72"
}
const _hoisted_10 = { class: "rounded-md p-3 my-2 box w-1/2 md:w-1/3 print:1/3" }
const _hoisted_11 = {
  id: "chartB",
  class: "w-full h-72"
}
const _hoisted_12 = { class: "rounded-md p-3 my-2 box w-full md:w-1/3 print:1/3" }
const _hoisted_13 = {
  id: "chartC",
  class: "w-full h-72"
}
const _hoisted_14 = { class: "rounded-md p-3 box" }
const _hoisted_15 = { class: "flex items-center mb-2" }
const _hoisted_16 = { class: "my-2 fff" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "rounded-md border shadow" }
const _hoisted_19 = { class: "rounded-sm" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  style: {"color":"#921e37"}
}
const _hoisted_24 = {
  key: 1,
  style: {"color":"#cd5f3b"}
}
const _hoisted_25 = {
  key: 2,
  style: {"color":"#706a00ff"}
}
const _hoisted_26 = {
  key: 3,
  style: {"color":"#61c08f"}
}
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "flex items-center w-full print:flex-wrap" }
const _hoisted_34 = { class: "w-36 print:w-full" }
const _hoisted_35 = ["title"]
const _hoisted_36 = ["title"]
const _hoisted_37 = ["title"]
const _hoisted_38 = ["title"]
const _hoisted_39 = ["title"]
const _hoisted_40 = ["title"]
const _hoisted_41 = ["title"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "flex items-center w-full flex-wrap" }
const _hoisted_44 = { class: "w-1/2" }
const _hoisted_45 = { class: "w-1/2" }
const _hoisted_46 = { class: "mt-2 w-full" }
const _hoisted_47 = { class: "mt-2 w-full" }
const _hoisted_48 = { class: "px-2" }
const _hoisted_49 = { class: "mt-3" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 1,
  hidden: ""
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = {
  key: 1,
  hidden: ""
}
const _hoisted_65 = {
  class: "w-full flex items-center",
  style: {"color":"#fff","font-size":"16px"}
}
const _hoisted_66 = {
  class: "ml-2",
  id: "pc"
}
const _hoisted_67 = {
  class: "w-full flex items-center",
  style: {"color":"#fff","font-size":"16px"}
}
const _hoisted_68 = {
  class: "ml-2",
  id: "mb"
}

import request from "../../common/request";
import { transformDate } from "../../common/tools";
import { useRouter, useRoute } from "vue-router";
import { computed, defineComponent, onMounted, h } from "vue";
import { ref, reactive, toRaw } from "vue";
import { message, TableProps } from 'ant-design-vue';
import { v4 as uuidv4 } from "uuid";
import * as echarts from 'echarts';
import { langList } from "../../common/lang";
import { getFactoryName, getGroupName, transformBeiJingDate, transformLocalDate } from "../../common/tools";
import htmlToPdf from '../../common/htmlToPdf';
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

interface Option {
    value: string;
    label: string;
    disabled?: boolean;
    children?: Option[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MWReportInfo',
  setup(__props) {

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
getLang();

const route = useRoute()
let reportInfo: any = ref({})
let chartData: any = ref([])
let chartDataB: any = ref([]);
let incidents: any = ref({})
let faultMode: any = ref(null)
let edit = ref(false)
let weekReports: any = ref([])
let statusList: any = ref([  //设备状态
    { label: langObj.value['故障'], value: '故障' },
    { label: langObj.value['警戒'], value: '警戒' },
    { label: langObj.value['可用'], value: '可用' },
    { label: langObj.value['健康'], value: '健康' },
    { label: langObj.value['短暂开机'], value: '短暂开机' },
    { label: langObj.value['未开机'], value: '未开机' },
    { label: langObj.value['传输异常'], value: '传输异常' },
])
let markList: any = ref([    //变化趋势
    { label: langObj.value['明显发展'], value: '明显发展' },
    { label: langObj.value['发展'], value: '发展' },
    { label: langObj.value['轻微发展'], value: '轻微发展' },
    { label: langObj.value['异常特征减弱'], value: '异常特征减弱' },
    { label: langObj.value['有变化'], value: '有变化' },
    { label: langObj.value['无明显变化'], value: '无明显变化' },
    { label: langObj.value['恢复健康'], value: '恢复健康' },
])
let gradeList = [
    { value: -1, label: '健康' },
    { value: 0, label: '可用' },
    { value: 1, label: '警戒' },
    { value: 2, label: '故障' },
];
let cascaderOptions: any = ref([])
const filter = (inputValue: string, path: Option[]) => {
    return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};

let tableDataSave: any = ref([])
let tableData: any = ref([])
let isShowFaultCause = ref(false)
let isShowFaultSuggest = ref(false)

let faultInfoList: any = []

let reportType: any = ref(3)

let getDiagLang = (diagnosticNotes) => {
  return diagnosticNotes.replace('现场维修', getLanguage('现场维修'))
};

let columns = [
    {
        title: langObj.value['设备名称'],
        dataIndex: 'machineName',
        slots: { customRender: 'machineName' },
        customCell: (_: any, index: any) => ({ rowspan: _.span, }),
        align: "center"
    },
    {
        title:  langObj.value['设备区域'],
        dataIndex: 'groupName',
        sorter: true, slots: { customRender: 'groupName' },
        customCell: (_: any, index: any) => ({ rowspan: _.span, }),
        align: "center"
    },
    {
        title:  langObj.value['设备状态'],
        dataIndex: 'status',
        sorter: true,
        customCell: (_: any, index: any) => ({ rowspan: _.span, }),
        slots: { customRender: 'status' },
        align: "center"
    },
    {
        title:  langObj.value['状态变化'],
        dataIndex: 'mark',
        sorter: true,
        slots: { customRender: 'mark' },
        customCell: (_: any, index: any) => ({ rowspan: _.span, }),
        align: "center"
    },
    {
        title:  langObj.value['诊断结果'],
        dataIndex: 'diagnosisDetails',
        slots: { customRender: 'diagnosisDetails' },
        align: "center"
    },
    {
        width: '200px',
        dataIndex: 'faultCause',
        slots: { title: 'faultCauseTitle', customRender: 'faultCause' },
        align: "center"
    },
    {
        width: '200px',
        dataIndex: 'faultSuggest',
        slots: { title: 'faultSuggestTitle', customRender: 'faultSuggest' },
        align: "center"
    },
    {
        title: reportType.value === 3 ?  langObj.value['本周检修/检查'] :  langObj.value['本月检修/检查'],
        dataIndex: 'repairList',
        slots: { customRender: 'repairList' },
        align: "center"
    }
]

let chartShow = ref(false)

let startTime: any = ref('')
let endTime: any = ref('')
let diagnosticManagerList:any = ref([])
let diagnosticManager:any = ref('')

// 修改报告
const handleEdit = () => {
    edit.value = true
}

// 取消
const handleCancle = () => {
    edit.value = false
    dealWithData()
}

// 保存
const handleSave = async () => {
    let machineIds = tableDataSave.value.map((p: any) => p.machineId)
    machineIds = [... new Set(machineIds)]
    let weekReport: any = []
    machineIds.map((machineId: any) => {
        let info = tableDataSave.value.find((p: any) => p.machineId === machineId)
        let list = tableDataSave.value.filter((p: any) => p.machineId === machineId)
        let diagnosisDetails: any = []
        list && list.length && list.map((d: any) => {
            if (Array.isArray(d.faultEvent)) {
                d.faultEvent = d.faultEvent.pop()
            }
            diagnosisDetails.push({
                diagnoseMessage: d.diagnoseMessage,
                diagnoseMessageEng: d.diagnoseMessageEng,
                faultCause: d.faultCause,
                faultCauseEng: d.faultCauseEng,
                faultEvent: d.faultEvent,
                faultSuggest: d.faultSuggest,
                faultSuggestEng: d.faultSuggestEng,
                grade: d.grade,
            })
        })

        weekReport.push({
            groupId: info.groupId, //
            groupName: info.groupName,
            machineId: info.machineId,
            machineName: info.machineName,
            mark: info.mark,
            markSort: markList.value.findIndex((ele: any) => ele.label === info.mark),
            status: info.status,
            statusSort: statusList.value.findIndex((ele: any) => ele.label === info.status),
            diagnosisDetails,
        })

    })

    weekReport.map((d:any, index:any) => {
        let oldInfo = weekReports.value.find((p:any) => p.machineId === d.machineId)

        let isChanged = false
        if(d.status !== oldInfo.status) {
            isChanged = true
        }
        if(d.mark !== oldInfo.mark) {
            isChanged = true
        }

        let newList = d.diagnosisDetails.map((p:any) => ({
            diagnoseMessage: p.diagnoseMessage,
            diagnoseMessageEng: p.diagnoseMessageEng,
            faultCause: p.faultCause,
            faultCauseEng: p.faultCauseEng,
            faultEvent: p.faultEvent,
            faultSuggest: p.faultSuggest,
            faultSuggestEng: p.faultSuggestEng,
            grade: p.grade,
        }))

        let oldList = oldInfo.diagnosisDetails.map((p:any) => ({
            diagnoseMessage: p.diagnoseMessage,
            diagnoseMessageEng: p.diagnoseMessageEng,
            faultCause: p.faultCause,
            faultCauseEng: p.faultCauseEng,
            faultEvent: p.faultEvent,
            faultSuggest: p.faultSuggest,
            faultSuggestEng: p.faultSuggestEng,
            grade: p.grade,
        }))

        if(JSON.stringify(newList) !== JSON.stringify(oldList)) {
            isChanged = true
        }
        d.isChanged = isChanged
    })

    let params = {}

    if (reportInfo.value.type === 3) {
        params = {
            ...reportInfo.value,
            weekReport
        }
    } else {
        params = {
            ...reportInfo.value,
            monthReport: weekReport
        }
    }

    let result = await request.put('/api/reports', params)
    if (result?.data) {
        edit.value = false
        init()
        message.success('操作成功')
    } else {
        message.warning('操作失败')
    }

}

// 新增
const handleCreate = (index: any) => {
    let data = tableData.value.find((p: any) => p.machineId === tableData.value[index].machineId && p.span)
    data.span++
    let form = {
        ...tableData.value[index],
        diagnoseMessage: "",
        faultCause: "",
        faultEvent: "",
        faultSuggest: "",
        grade: -1,
        span: 0,
        faultSuggestList: [],
        faultCauseList: [],
    }

    tableData.value.splice(index + 1, 0, form)
}

// 删除
const deleteEle = (index: any) => {
    if (tableData.value[index].span) {
        if (tableData.value[index].span > 1) {
            // 下级继承
            tableData.value[index + 1].span = tableData.value[index].span - 1
            tableData.value.splice(index, 1)
        } else {
            if(tableData.value[index].span === 1) {
                tableData.value[index] = {
                    ...tableData.value[index],
                    diagnoseMessage: null,
                    faultCause: null,
                    faultEvent: null,
                    faultSuggest: null,
                    grade: null,
                    span: 1,
                    faultSuggestList: null,
                    faultCauseList: null,
                }
            } else {
                tableData.value.splice(index, 1)
            }
        }
    } else {
        // 上级span-1
        let data = tableData.value.find((p: any) => p.machineId === tableData.value[index].machineId && p.span)
        data.span--
        tableData.value.splice(index, 1)
    }
}

// 设备跳转
const router = useRouter()
const handleMachineName = (ev: any) => {
    let memberInfo = JSON.parse(localStorage.getItem('memberInfo') || '')
    if (ev.machineId && memberInfo.machines.find((p: any) => p.id === ev.machineId)) {
        localStorage.setItem('machineId', ev.machineId)
        router.push('/diagnosis/intelligent')
    }
}

// 本周设备健康总览绘图
const initChartA = () => {
    const ec = echarts as any;
    if (!document.getElementById('chartA')) return

    let myChart = ec.init(document.getElementById('chartA'));
    myChart.clear()
    if (!chartData.value || !chartData.value.length) {
        myChart.clear()
        return
    }
    const option = {
        color: chartData.value.map((p: any) => p.color),

        tooltip: {
            trigger: 'item',
        },
        legend: {
            bottom: 'center',
            orient: 'vertical',
            left: '5%',
            textStyle: {
                color: '#fff',
            },
            formatter: function (name: any) {
                return `${langObj.value[name]} ( ${ option.series[0].data.find((p: any) => p.name === name)?.value} )`;
            },
        },
        series: [
            {
                name: langObj.value['设备状态'],
                type: 'pie',
                radius: ['50%', '70%'],
                center: ['50%', '50%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 3,
                },
                label: {
                    show: false,
                    position: 'center',
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: '14',
                        fontWeight: 'normal',
                    },
                },
                labelLine: {
                    show: false,
                },
                data: chartData.value,
            },
        ],
    };

    myChart.setOption(option);
}

// 本周设备事件提醒总览
const initChartB = async() => {
    const config = {
        params: {
            factoryId: reportInfo.value?.factoryId,
            begin: startTime.value,
            end: endTime.value,
        },
        headers: {
            requestId: uuidv4(),
        },
    };
    let result = await request.get('/api/factory/score', config)
    let list:any = []
    if(result?.data?.length > 0) {
        list = result.data
    }

    let xData = list.map((p:any) => p.date).map((d:any) => transformLocalDate(d))
    let yData = list.map((p:any) => p.score)

    const ec = echarts as any;
    if (!document.getElementById('chartB')) return
    let myChart = ec.init(document.getElementById('chartB'));
    myChart.clear()

    let  option = {
        tooltip: {
          hideDelay: 100,
          transitionDuration: 0,
          animation: false ,
          trigger: 'axis',
          axisPointer: {
            type: 'cross' ,
          }
        },
        grid: {
          right: '11%',
          left: '12%',
        },
        toolbox: {
          trigger: 'axis'
        },
        dataZoom: [{ type: 'inside' }],
        xAxis: [
          {
            show: true,
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            data: xData,
            splitLine: {
              show: true,
              lineStyle: {
                opacity: 0.3
              }
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
              showMaxLabel: true
            },
          }
        ],
        yAxis: {
            type: 'value',
            scale: true,
            min: 0,
            max: 100,
            splitNumber: 5,
            splitLine: {
              lineStyle: {
                color: ['rgb(117, 116, 116)', 'rgb(117, 116, 116)', 'rgb(117, 116, 116)', 'rgba(250, 60, 88, 1)', 'rgba(254, 178, 7, 1)', 'rgb(117, 116, 116)']
              }
            },
        },
        series: [
            {
                data: yData,
                type: 'line'
            }
        ]
    };

    myChart.setOption(option)

}

// 故障模式统计(本年)
const initChartC = () => {
    let data = reportInfo.value.expertFaultModeStatistics || {}
    let chartData: any[] = [];

    Object.keys(data).forEach(ele => {
        let min = {
            value: data[ele],
            name: ele,
        }
        chartData.push(min)
    })

    const ec = echarts as any;
    if (!document.getElementById('chartC')) return

    let myChart = ec.init(document.getElementById('chartC'));
    myChart.clear()
    const option = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            bottom: 'center',
            orient: 'vertical',
            left: '2%',
            textStyle: {
                color: "#fff"
            },
            formatter: function (name: any) {
                return `${langObj.value[name] || name}`;
            },
        },
        series: [
            {
                name: langObj.value['故障模式'],
                type: 'pie',
                radius: ['50%', '70%'],
                center: ['65%', '50%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 3,
                },
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: '14',
                        fontWeight: 'normal'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartData
            }
        ]
    };


    myChart.setOption(option)

}


// 处理数据
const dealWithData = async() => {
    const {
        weekReport,
        monthReport,
    } = reportInfo.value;

    columns[7].title = reportInfo.value.type === 3 ? langObj.value['本周检修/检查'] : langObj.value['本月检修/检查']

    let reportList: any = reportInfo.value.type === 3 ? weekReport : monthReport

    let statusList2 = reportList.map((d: any) => d.status);
    let healthList = statusList2.filter((p: any) => p === '健康');
    let availableList = statusList2.filter((p: any) => p === '可用');
    let alertList = statusList2.filter((p: any) => p === '警戒');
    let faultList = statusList2.filter((p: any) => p === '故障');
    let notbootList = statusList2.filter((p: any) => p === '未开机');

    chartData.value = [];
    healthList.length && chartData.value.push({ value: healthList.length, name: '健康', sort: 0, color: '#1CC48B' });
    availableList.length && chartData.value.push({ value: availableList.length, name: '可用', sort: 1, color: '#CEE008' });
    alertList.length && chartData.value.push({ value: alertList.length, name: '警戒', sort: 2, color: '#DF572D' });
    faultList.length && chartData.value.push({ value: faultList.length, name: '故障', sort: 3, color: '#A20335' });
    notbootList.length && chartData.value.push({ value: notbootList.length, name: '未开机', sort: 4, color: 'rgb(162, 166, 171)' });

    if (reportList && reportList.length > 0) {
        reportList.forEach((element: any, i:any) => {
            element.classIndex = i
            element.markSort = markList.value.findIndex((ele: any) => ele.value === element.mark)
            element.statusSort = statusList.value.findIndex((ele: any) => ele.value == element.status)
            if (element.repair) {
                element.repairList = element.repair.split("|")
            } else {
                element.repairList = []
            }
        });

        weekReports.value = reportList
    }

    let config = {
        params: {
            factoryId: reportInfo.value.factoryId,
            begin: startTime.value,
            end: endTime.value,
        },
        headers: {
            requestId: uuidv4(),
        },
    }

    let warningResult = await request.get('/api/report/warning', config)
    let status1 = [0, 0]
    let status2 = [0, 0]
    let status3 = [0, 0]
    if(warningResult?.data) {
        status1 = [warningResult.data.type1[0], warningResult.data.type4[0]]
        status2 = [warningResult.data.type1[1], warningResult.data.type4[1]]
        status3 = [warningResult.data.type1[2], warningResult.data.type4[2]]
        chartDataB.value = [status1, status2, status3];
    }

    chartShow.value = true
    setTimeout(() => {
        initChartA()
        initChartB()
        initChartC()
    }, 1000);

    let sortTwo = (a:any, b:any) => {
        if(a.statusSort > b.statusSort) {
            return 1
        } else if(a.statusSort === b.statusSort) {
            if(a.markSort > b.markSort) {
                return 1
            } else {
                return -1
            }
        } else {
            return -1
        }
    }

    reportList.sort((a:any, b:any) => {return sortTwo(a, b)})

    // 新表格数据
    tableData.value = []
    reportList && reportList.map((item: any) => {
        if (item.diagnosisDetails && item.diagnosisDetails.length) {
            item.diagnosisDetails.map((son: any, index: any) => {
                tableData.value.push({
                    ...son,
                    machineName: item.machineName,
                    machineId: item.machineId,
                    // groupName: item.groupName,
                    groupName: getGroupName(item.groupId),
                    mark: item.mark,
                    status: item.status,
                    span: index === 0 ? item.diagnosisDetails.length : 0,
                    groupId: item.groupId,
                    repairList: item.repairList,
                    classIndex: item.classIndex,
                })
            })
        } else {
            tableData.value.push({
                machineName: item.machineName,
                machineId: item.machineId,
                // groupName: item.groupName,
                groupName: getGroupName(item.groupId),
                mark: item.mark,
                status: item.status,
                span: 1,
                groupId: item.groupId,
                repairList: item.repairList,
                classIndex: item.classIndex,
            })
        }
    })

    tableData.value.map((d: any) => {
        if (d.faultCause) {

            let fc = getLanguage(d.faultCause)

            let faultCause1 = ''
            if(language.value === 'Chinese') {
                faultCause1 = fc
            } else if(language.value === 'English') {
                faultCause1 = d.faultCauseEng || fc
            } else {
                faultCause1 = getChineseFt(fc)
            }
            d.faultCauseList = faultCause1.replaceAll('\n', '\r\n').split('\r\n').filter((d: any) => d)
        }
        if (d.faultSuggest) {
            let fs = getLanguage(d.faultSuggest)
            let faultSuggest1 = ''
            if(language.value === 'Chinese') {
                faultSuggest1 = fs
            } else if(language.value === 'English') {
                faultSuggest1 = d.faultSuggestEng ||fs
            } else {
                faultSuggest1 = getChineseFt(fs)
            }
            d.faultSuggestList = faultSuggest1.replaceAll('\n', '\r\n').split('\r\n').filter((d: any) => d)
        }
    })

    tableDataSave.value = JSON.parse(JSON.stringify(tableData.value))
    selectManage(null)
}

// 排序
const tableChange = (pagination: any, filters: any, sorter: any) => {
    if (!sorter.order) {
        return
    }

    function compare(property: any, sort: any) {
        return function (a: any, b: any) {
            var value1 = a[property];
            var value2 = b[property];
            return sort === 'ascend' ? value1 - value2 : value2 - value1
        }
    }
    // 设备区域
    if (sorter.field === 'groupName') {
        tableData.value.sort(compare(sorter.field, sorter.order))
    }

    // 设备状态
    if (sorter.field === 'status') {
        let machineIds: any = tableData.value.map((p: any) => p.machineId)
        machineIds = [...new Set(machineIds)]
        let machines: any = []
        machineIds.map((d: any) => {
            let list = tableData.value.filter((p: any) => p.machineId === d)
            machines.push({
                list,
                statusSort: statusList.value.findIndex((ele: any) => ele.label === langObj.value[list[0].status])
            })
        })
        machines.sort(compare('statusSort', sorter.order))
        let tableList: any = []
        machines.map((d: any) => {
            tableList = tableList.concat(d.list)
        })

        tableData.value = tableList
    }

    // 状态变化
    if (sorter.field === 'mark') {
        let machineIds: any = tableData.value.map((p: any) => p.machineId)
        machineIds = [...new Set(machineIds)]
        let machines: any = []
        machineIds.map((d: any) => {
            let list = tableData.value.filter((p: any) => p.machineId === d)
            machines.push({
                list,
                markSort: markList.value.findIndex((ele: any) => ele.label === langObj.value[list[0].mark])
            })
        })
        machines.sort(compare('markSort', sorter.order))
        let tableList: any = []
        machines.map((d: any) => {
            tableList = tableList.concat(d.list)
        })

        tableData.value = tableList
    }

}

// 选择诊断经理
const selectManage = async(ev: any) => {
    let list = tableDataSave.value
    if(ev) {
        const config = {
            params: {
                diagnosticManager: ev
            },
            headers: {
                requestId: uuidv4(),
            },
        }
        let result = await request.get('/api/principal/all', config)
        let machineIds:any = []
        if(result?.data?.length) {
            machineIds = result.data.map((p:any) => p.machineId)
        }
        tableData.value = list.filter((p:any) => machineIds.includes(p.machineId))
    } else {
        tableData.value = list
    }
}

// 获取faultInfos
const getFaultInfos = () => {
    cascaderOptions.value = [];
    const config = {
        headers: {
            requestId: uuidv4(),
        },
    };
    request.post("/api/faultinfos", { FeatureType: '' }, config).then((res: any) => {
        if (res) {
            faultInfoList = res.data
            let list = res.data
            let expects = list.filter((item: { featureType: string; }) => item.featureType === "Expect")
            let commons = list.filter((item: { featureType: string; }) => item.featureType === "Common")
            let others = list.filter((item: { featureType: string; }) => item.featureType === "Other")
            let expectList: any[] = []
            let commonsList: any[] = []
            let othersList: any[] = []
            expects.forEach((item: any) => {
                if (expectList.findIndex((ele: any) => ele.value === item.segmentFault) === -1) {
                    expectList.push({
                        value: item.segmentFault,
                        label: item.segmentFault,
                    })
                }
            })

            commons.forEach((item: any) => {
                if (commonsList.findIndex((ele: any) => ele.value === item.segmentFault) === -1) {
                    commonsList.push({
                        value: item.segmentFault,
                        label: item.segmentFault,
                    })
                }
            })

            others.forEach((item: any) => {
                if (othersList.findIndex((ele: any) => ele.value === item.segmentFault) === -1) {
                    othersList.push({
                        value: item.segmentFault,
                        label: item.segmentFault,
                    })
                }
            })

            cascaderOptions.value = [
                {
                    value: '专业指标',
                    label: langObj.value['专业指标'],
                    children: expectList,
                },
                {
                    value: '振动指标',
                    label: langObj.value['振动指标'],
                    children: commonsList,
                },
                {
                    value: '其他',
                    label: langObj.value['其他'],
                    children: othersList,
                },
            ];
        }
    });
}

// 选择fault
const selectFault = (ev: any, index: any) => {
    if (ev && ev.length === 2) {
        let faultInfo = faultInfoList.find((p: any) => p.segmentFault === ev[1])

        if (faultInfo.faultCause) {
            tableData.value[index].faultCause = faultInfo.faultCause;
            tableData.value[index].faultCauseList = faultInfo.faultCause.split('\r\n').filter((d: any) => d)
        } else {
            tableData.value[index].faultCause = ''
            tableData.value[index].faultCauseList = []
        }

        if (faultInfo.faultSuggest) {
            tableData.value[index].faultSuggest = faultInfo.faultSuggest;
            tableData.value[index].faultSuggestList = faultInfo.faultSuggest.split('\r\n').filter((d: any) => d)
        } else {
            tableData.value[index].faultSuggest = ''
            tableData.value[index].faultSuggestList = []
        }

    }
}


let visible = ref(false)
let urlpc:any = ref('')
let urlmb:any = ref('')
const share = () => {
    urlpc.value = location.host + '/#/week-report/' + route.params.id + '?lang=' + language.value
    urlmb.value = location.host + '/#/week-report-mobile/' + route.params.id + '?lang=' + language.value
    visible.value = true
}

//复制功能
const copyUrl = (rf:any) => {
    let node = document.getElementById(rf)
    if(window.getSelection() && node) {
        window.getSelection()?.selectAllChildren(node);
    }
    let copy = document.execCommand("Copy");
    if (copy) {
        document.execCommand("Copy");
        message.success('复制完成')
    } else {
        message.warning('由于浏览器版本问题，复制失败，请手动复制~')
    }
}

let isEditable:any = ref(false)
const init = () => {
    chartShow.value = false
    getFaultInfos()
    const config = {
        params: {
            id: route.params.id
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    reportInfo.value = {}
    request.get("/api/reports/info", config).then((res) => {
        if (res && res.status === 200) {
            isEditable.value = true
            reportInfo.value = res.data
            reportType.value = res.data.type
            endTime.value = transformDate(reportInfo.value.date)
            let num = reportType.value === 3 ? 7 : 30
            startTime.value = transformDate(new Date(endTime.value).getTime() - (1000 * 60 * 60 * 24 * num))

            dealWithData()
        }
    });
}

onMounted(() => {
    init()
    // getManagers()
})

const getReportTitle = (title:any) => {
    if(!title) {
        title = ''
    }
    if(title.includes('周报')) {
        if(language.value === 'English') {
            let lanL = title.split('周报')
            title = getTranslation(lanL[0]) + ' weekly report'
        }else{
             let lanL = title.split('周报')
             title = getTranslation(lanL[0]) +  getLanguage('周报')
        }
    }

    if(title.includes('月报')) {
        if(language.value === 'English') {
            let lanL = title.split('月报')
            title = getTranslation(lanL[0]) + ' monthly report'
        }else{
             let lanL = title.split('月报')
            title = getTranslation(lanL[0]) +  getLanguage('月报')
        }
    }
    return title
}


// 获取诊断经理列表
const getManagers = async() => {
    const config = {
        params: {
            factoryId: "65e29561f747d7e32bbed049",
        },
        headers: {
            requestId: uuidv4(),
        },
    };
    let resultRole = await request.get("/api/roles", config)
    let rolelist:any = []
    if(resultRole?.data?.list) {
        rolelist = resultRole.data.list
    }
    let diagnosticManagerRoleId = rolelist.find((p:any) => p.name === '诊断工程师')?.id

    if(diagnosticManagerRoleId) {
        let config2 = {
            params: {
                roleId: diagnosticManagerRoleId,
                factoryId: "65e29561f747d7e32bbed049",
            },
            headers: {
                requestId: uuidv4(),
            },
        };
        let result2 = await request.get("/api/members", config2)
        if(result2?.data?.list) {
            diagnosticManagerList.value = result2.data.list
        }
    }

}

// 下载pdf
let loadingDown = ref(false)
const handleDown = async() => {
    loadingDown.value = true;	// 动画加载事件
    // 调用htmlToPdf工具函数
    let result = await htmlToPdf.getPdf('周报', 'a1' );
    loadingDown.value = false
    if(result) {
        message.success('下载成功')
    } else {
        message.warning('下载失败，请重试')
    }

}

// 下载excel
const exportToExcel = async () => {
  let res: any = await request.post("/api/reports/export-excel", {
    id: route.params.id,
    chartData: chartData.value,
    chartDataB: chartDataB.value,
    expertFaultModeStatistics: reportInfo.value.expertFaultModeStatistics,
    tableData: tableData.value
  });
  const bufferArray = res.data.data; // 提取 Buffer 数组
  const uint8Array = new Uint8Array(bufferArray); // 转换为 Uint8Array
  const dataBlob = new Blob([uint8Array], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(dataBlob, reportInfo.value.title + ".xlsx");
}





const getRowClassName = (record: any, index: any) => {
  // 根据索引设置不同的类名
  return record.classIndex % 2 === 0 ? "even-row" : "odd-row";
};
 
// 返回报告列表
const goBack = () => {
    localStorage.setItem('report_type', '3')
    router.back()
}

// 转繁体
const translateFt = (ev:any) => {
    let content:any = ''
    if(ev) {
        content = getChineseFt(ev)
    }
    return content
}


return (_ctx: any,_cache: any) => {
  const _component_RollbackOutlined = _resolveComponent("RollbackOutlined")!
  const _component_ShareAltOutlined = _resolveComponent("ShareAltOutlined")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_download_outlined = _resolveComponent("download-outlined")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_CloseCircleOutlined = _resolveComponent("CloseCircleOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      size: "large",
      spinning: _unref(loadingDown)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_RollbackOutlined, {
            onClick: goBack,
            class: "ml-5 cursor-pointer",
            style: {"font-size":"18px"}
          }),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(langObj)['报告统计时间']) + ": " + _toDisplayString(_unref(transformLocalDate)(_unref(startTime))) + " -- " + _toDisplayString(_unref(transformLocalDate)(_unref(endTime))), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(langObj)['报告日期']) + ": " + _toDisplayString(_unref(transformLocalDate)(_unref(endTime))), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(getReportTitle(_unref(reportInfo).title)), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(transformLocalDate)(_unref(endTime))), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_unref(isEditable)&&_unref(language)=='Chinese')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (share())),
                  "nz-button": "",
                  nzType: "text"
                }, [
                  _createVNode(_component_ShareAltOutlined, { class: "cursor-pointer" })
                ]))
              : _createCommentVNode("", true),
            (_unref(isEditable)&&_unref(language)=='Chinese')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleEdit())),
                  "nz-button": "",
                  nzType: "text",
                  class: "ml-2"
                }, [
                  _createVNode(_component_EditOutlined, { class: "cursor-pointer" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleDown())),
              "nz-button": "",
              nzType: "text",
              class: "ml-2 nz-button"
            }, [
              _createVNode(_component_download_outlined),
              _cache[14] || (_cache[14] = _createElementVNode("div", null, "PDF", -1))
            ]),
            (_unref(language)=='Chinese')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (exportToExcel())),
                  "nz-button": "",
                  nzType: "text",
                  class: "ml-2 nz-button"
                }, [
                  _createVNode(_component_download_outlined),
                  _cache[15] || (_cache[15] = _createElementVNode("div", null, "EXCEL", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_unref(reportType) === 3 ? _unref(langObj)['本周设备健康总览'] : _unref(langObj)['本月设备健康总览']), 1),
            _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
              [_vShow, _unref(chartShow)]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, _toDisplayString(_unref(reportType) === 3 ? _unref(langObj)['本周设备分数趋势'] : _unref(langObj)['本月设备分数趋势']), 1),
            _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
              [_vShow, _unref(chartShow)]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, _toDisplayString(_unref(langObj)['故障模式统计(本年)']), 1),
            _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
              [_vShow, _unref(chartShow)]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h4", _hoisted_16, _toDisplayString(_unref(langObj)['设备详情清单']), 1),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
            (_unref(edit))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleCancle())),
                    class: "mr-4 bg-gray-200 rounded-sm px-4 py-1 cursor-pointer hover:bg-opacity-50"
                  }, _toDisplayString(_unref(langObj)['取消']), 1),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSave())),
                    class: "mr-1 bg-blue-500 text-gray-50 rounded-sm px-4 py-1 cursor-pointer hover:bg-opacity-60"
                  }, _toDisplayString(_unref(langObj)['保存']), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_a_table, {
                dataSource: _unref(tableData),
                columns: _unref(columns),
                pagination: false,
                onChange: tableChange,
                size: "small",
                "row-class-name": getRowClassName
              }, {
                faultCauseTitle: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_unref(langObj)['故障原因']), 1),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                    (!_unref(isShowFaultCause) && !_unref(edit))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_isRef(isShowFaultCause) //@ts-ignore
 ? isShowFaultCause.value = true : isShowFaultCause = true))
                        }, _toDisplayString(_unref(langObj)['展开']), 1))
                      : _createCommentVNode("", true),
                    (_unref(isShowFaultCause) && !_unref(edit))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_isRef(isShowFaultCause) //@ts-ignore
 ? isShowFaultCause.value = false : isShowFaultCause = false))
                        }, _toDisplayString(_unref(langObj)['隐藏']), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                faultSuggestTitle: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(_unref(langObj)['建议及措施']), 1),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                    (!_unref(isShowFaultSuggest) && !_unref(edit))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(isShowFaultSuggest) //@ts-ignore
 ? isShowFaultSuggest.value = true : isShowFaultSuggest = true))
                        }, _toDisplayString(_unref(langObj)['展开']), 1))
                      : _createCommentVNode("", true),
                    (_unref(isShowFaultSuggest) && !_unref(edit))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_isRef(isShowFaultSuggest) //@ts-ignore
 ? isShowFaultSuggest.value = false : isShowFaultSuggest = false))
                        }, _toDisplayString(_unref(langObj)['隐藏']), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                machineName: _withCtx(({ text, record }) => [
                  _createElementVNode("a", null, _toDisplayString(_unref(getTranslation)(text)), 1)
                ]),
                groupName: _withCtx(({ text, record }) => [
                  _createElementVNode("a", null, _toDisplayString(_unref(getTranslation)(text)), 1)
                ]),
                status: _withCtx(({ text, record }) => [
                  (!_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (text === '故障')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(langObj)[text]), 1))
                          : (text === '警戒')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(langObj)[text]), 1))
                            : (text === '可用')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(langObj)[text]), 1))
                              : (text === '健康')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(langObj)[text]), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(langObj)[text]), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createVNode(_component_a_select, {
                          class: "p-2 rounded-md border border-gray-200 w-full focus:outline-none",
                          value: record.status,
                          "onUpdate:value": ($event: any) => ((record.status) = $event),
                          options: _unref(statusList)
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                mark: _withCtx(({ text, record }) => [
                  (!_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("span", null, _toDisplayString(_unref(langObj)[text]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_unref(edit))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createVNode(_component_a_select, {
                                class: "p-2 rounded-md border border-gray-200 w-full focus:outline-none",
                                value: record.mark,
                                "onUpdate:value": ($event: any) => ((record.mark) = $event),
                                options: _unref(markList)
                              }, null, 8, ["value", "onUpdate:value", "options"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                diagnosisDetails: _withCtx(({ text, record, index }) => [
                  (!_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            (record.grade === -1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  title: _unref(langObj)[record.faultEvent] || record.faultEvent,
                                  class: "px-2 py-1 rounded-sm w-full",
                                  style: {"color":"#61c08f","border":"1px solid #61c08f"}
                                }, _toDisplayString(_unref(langObj)[record.faultEvent] || record.faultEvent), 9, _hoisted_35))
                              : _createCommentVNode("", true),
                            (record.grade === 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  title: _unref(langObj)[record.faultEvent] || record.faultEvent,
                                  class: "px-2 py-1 rounded-sm w-full",
                                  style: {"color":"#CEE008","border":"1px solid #CEE008"}
                                }, _toDisplayString(_unref(langObj)[record.faultEvent] || record.faultEvent), 9, _hoisted_36))
                              : _createCommentVNode("", true),
                            (record.grade === 1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  title: _unref(langObj)[record.faultEvent] || record.faultEvent,
                                  class: "px-2 py-1 rounded-sm w-full",
                                  style: {"color":"#DF572D","border":"1px solid #DF572D"}
                                }, _toDisplayString(_unref(langObj)[record.faultEvent] || record.faultEvent), 9, _hoisted_37))
                              : _createCommentVNode("", true),
                            (record.grade === 2)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  title: _unref(langObj)[record.faultEvent] || record.faultEvent,
                                  class: "px-2 py-1 rounded-sm w-full",
                                  style: {"color":"#A20335","border":"1px solid #A20335"}
                                }, _toDisplayString(_unref(langObj)[record.faultEvent] || record.faultEvent), 9, _hoisted_38))
                              : _createCommentVNode("", true)
                          ]),
                          (_unref(language)=='Chinese')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                title: record.diagnoseMessage,
                                class: "flex-1 px-2 print:py-2"
                              }, _toDisplayString(record.diagnoseMessage), 9, _hoisted_39))
                            : _createCommentVNode("", true),
                          (_unref(language)=='English')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                title: record.diagnoseMessageEng || record.diagnoseMessage,
                                class: "flex-1 px-2 print:py-2"
                              }, _toDisplayString(record.diagnoseMessageEng || record.diagnoseMessage), 9, _hoisted_40))
                            : _createCommentVNode("", true),
                          (_unref(language)=='Chinese_ft')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                title: translateFt(record.diagnoseMessage),
                                class: "flex-1 px-2 print:py-2"
                              }, _toDisplayString(translateFt(record.diagnoseMessage)), 9, _hoisted_41))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_a_cascader, {
                              class: "w-full",
                              value: record.faultEvent,
                              "onUpdate:value": ($event: any) => ((record.faultEvent) = $event),
                              options: _unref(cascaderOptions),
                              "show-search": { filter: filter },
                              onChange: ($event: any) => (selectFault($event, index)),
                              allowClear: false
                            }, null, 8, ["value", "onUpdate:value", "options", "show-search", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_a_select, {
                              placeholder: _unref(langObj)['严重程度'],
                              value: record.grade,
                              "onUpdate:value": ($event: any) => ((record.grade) = $event),
                              class: "p-2 rounded-md border border-gray-200 w-full focus:outline-none"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeList), (grade, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: index,
                                    value: grade.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(langObj)[grade.label]), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["placeholder", "value", "onUpdate:value"])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_a_textarea, {
                              class: "w-full",
                              cols: 100,
                              value: record.diagnoseMessage,
                              "onUpdate:value": ($event: any) => ((record.diagnoseMessage) = $event),
                              maxlength: -1,
                              rows: 3
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_a_textarea, {
                              placeholder: "English",
                              class: "w-full",
                              cols: 100,
                              value: record.diagnoseMessageEng,
                              "onUpdate:value": ($event: any) => ((record.diagnoseMessageEng) = $event),
                              maxlength: -1,
                              rows: 3
                            }, null, 8, ["value", "onUpdate:value"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_CloseCircleOutlined, {
                            onClick: ($event: any) => (deleteEle(index)),
                            class: "cursor-pointer"
                          }, null, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (handleCreate(index)),
                            class: "mr-1 bg-blue-300 text-gray-50 rounded-md px-4 py-1 cursor-pointer hover:bg-blue-400 w-full"
                          }, _toDisplayString(_unref(langObj)['新增']), 9, _hoisted_50)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                faultCause: _withCtx(({ record }) => [
                  (_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createVNode(_component_a_textarea, {
                          value: record.faultCause,
                          "onUpdate:value": ($event: any) => ((record.faultCause) = $event),
                          rows: 4
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_textarea, {
                          placeholder: "English",
                          style: {"margin-top":"8px"},
                          value: record.faultCauseEng,
                          "onUpdate:value": ($event: any) => ((record.faultCauseEng) = $event),
                          rows: 4
                        }, null, 8, ["value", "onUpdate:value"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.faultCauseList || [], (txt, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            (i <= 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(txt), 1))
                              : _createCommentVNode("", true),
                            (i > 1 && _unref(isShowFaultCause))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(txt), 1))
                              : _createCommentVNode("", true),
                            (i > 1 && !_unref(isShowFaultCause))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                  (i === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, "......"))
                                    : _createCommentVNode("", true),
                                  (i > 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                ]),
                faultSuggest: _withCtx(({ record }) => [
                  (_unref(edit))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createVNode(_component_a_textarea, {
                          value: record.faultSuggest,
                          "onUpdate:value": ($event: any) => ((record.faultSuggest) = $event),
                          rows: 4
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_textarea, {
                          placeholder: "English",
                          style: {"margin-top":"8px"},
                          value: record.faultSuggestEng,
                          "onUpdate:value": ($event: any) => ((record.faultSuggestEng) = $event),
                          rows: 4
                        }, null, 8, ["value", "onUpdate:value"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.faultSuggestList || [], (txt, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            (i <= 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(txt), 1))
                              : _createCommentVNode("", true),
                            (i > 1 && _unref(isShowFaultSuggest))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(txt), 1))
                              : _createCommentVNode("", true),
                            (i > 1 && !_unref(isShowFaultSuggest))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  (i === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, "......"))
                                    : _createCommentVNode("", true),
                                  (i > 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                ]),
                repairList: _withCtx(({ text }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(text, (repair, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "py-1 border-b border-gray-300 text-xs"
                    }, _toDisplayString(_unref(getDiagLang)(repair)), 1))
                  }), 128))
                ]),
                _: 1
              }, 8, ["dataSource", "columns"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["spinning"]),
    _createVNode(_component_a_modal, {
      width: 850,
      maskClosable: false,
      visible: _unref(visible),
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
      footer: null,
      title: _unref(langObj)['周报转发：复制链接转发，用户可在电脑端或手机端查看']
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", null, _toDisplayString(_unref(langObj)['pc端链接']) + ": ", 1),
          _createElementVNode("div", _hoisted_66, _toDisplayString(_unref(urlpc)), 1),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
          _createElementVNode("div", {
            class: "cursor-pointer",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (copyUrl('pc')))
          }, [
            _createVNode(_component_CopyOutlined)
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", null, _toDisplayString(_unref(langObj)['手机端链接']) + ": ", 1),
          _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(urlmb)), 1),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
          _createElementVNode("div", {
            class: "cursor-pointer",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (copyUrl('mb')))
          }, [
            _createVNode(_component_CopyOutlined)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})